<template>
  <div class="valid-code-container">
    <div class="title">
      <span>{{ isLogin ? '登录' : '绑定' }}</span>
      <span class="high-light">智库</span>
    </div>
    <div class="sub-title">{{ isLogin ? '填写您的账号和密码登录' : '绑定已有账号' }}</div>
    <div class="form">
      <el-form ref="formRef" :model="loginForm" :rules="formRules">
        <el-form-item prop="username">
          <div class="inpt-label">账号</div>
          <el-input v-model="loginForm.username" placeholder="用户名/手机号/邮箱" />
        </el-form-item>
        <el-form-item prop="password">
          <div class="pwd flex flex_col">
            <div class="inpt-label">密码</div>
            <el-input v-model="loginForm.password" placeholder="输入密码" type="password" />
            <div class="tip" v-if="!isOverseaIp" @click="changeCurrentCom('FindPwdByPhone', false)">忘记密码?</div>
          </div>
        </el-form-item>
        <el-form-item prop="code">
          <div class="validate">
            <div class="inpt-label">验证码</div>
            <div class="input flex align_items_ctr">
              <el-input v-model="loginForm.code" placeholder="输入验证码" @keyup.native.enter="LoginClick"> </el-input>
              <div class="base64img cur" @click="getValidateCode">
                <img :src="codeImg" alt="" />
              </div>
            </div>
          </div>
        </el-form-item>
        <div v-if="loginTip" class="login-tip">{{ loginTip }}</div>
        <div v-else class="login-tip "></div>

        <el-form-item align="center">
          <div class="login_btns">
            <div class="login-btn" @click="LoginClick">{{ isLogin ? '登录' : '绑定登录' }}</div>
            <div class="login-btn" @click="ipLoginClick">IP登录</div>
          </div>
          <div class="other_login">
            <div v-if="!isOverseaIp" class="regist-tip">
              没有帐户？<span class="regist-btn pointer" @click="changeCurrentCom('RegisterCom', false)">注册</span>
            </div>
            <div class="ip_add">您的IP：{{ IP }}</div>
          </div>

        </el-form-item>
      </el-form>
      <div class="form-bot" v-if="!isOverseaIp">
        <div class="gap-row">或者</div>
        <div class="other-btn flex" v-if="isLogin">
          <div class="btn phone-btn" @click="changeCurrentCom('PhoneCom')">手机号登录</div>
          <div class="btn code-btn" @click="changeCurrentCom('QrCom')">扫码登录</div>
        </div>
        <div class="bind-count" v-else @click="bindPhoneLogin">绑定手机号登录</div>
      </div>
    </div>
  </div>
</template>
<script>

import JSEncrypt from 'jsencrypt'
import { getValidateCodeApi, login, getRSABase64PublicKey, ipLogin } from '@/apis/index.js'
import { mapState } from 'vuex'
export default {
  name: 'ValidCodeCom',
  props: {
    isLogin: {
      type: Boolean,
      default: true,
    },
    weixininfo: {
      type: String,
      default: '',
    },
    isOverseaIp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      codeImg: '',
      uuid: '',
      loginForm: {
        productCode: 'TDS',
        username: '',
        password: '',
        cid: '',
        code: '',
        rememberMe: false,
        weixininfo: '',
      },
      RSABase64PublicKey: '', //加密公钥
      formRules: {
        username: [{ required: true, message: '用户名不能为空', trigger: ['blur'] }],
        password: [{ required: true, message: '密码不能为空', trigger: ['blur'] }],
        code: [{ required: true, message: '不能为空', trigger: ['blur'] }],
      },
      loginTip: '',
    }
  },
  async mounted() {
    await this.getValidateCode()
    let res = await getRSABase64PublicKey()
    this.RSABase64PublicKey = `
    -----BEGIN PUBLIC KEY-----
    ${res.data}
    -----END PUBLIC KEY-----`
    sessionStorage.setItem('rsaPubKey', this.RSABase64PublicKey)
  },
  computed: {
    ...mapState(['IP']),
  },
  methods: {
    /* 获取验证码 */
    async getValidateCode() {
      let res = await getValidateCodeApi()
      // console.log(res);
      if (res.success) {
        this.codeImg = 'data:image/png;base64,' + res.data.img
        this.loginForm.cid = res.data.uuid
      }
    },
    /* 点击验证码 */
    codeClick() {
      this.getValidateCode()
    },
    changeCurrentCom(com, loginCom = true) {
      this.$emit('changeCom', com, loginCom)
    },
    //登录
    LoginClick() {
      this.$refs.formRef.validate(async (v) => {
        if (v) {
          this.loadingBtn = true
          this.loginForm.weixininfo = this.weixininfo
          let loginFormCopy = JSON.parse(JSON.stringify(this.loginForm))
          const { username, password } = loginFormCopy
          const jsencrypt = new JSEncrypt()
          jsencrypt.setPublicKey(this.RSABase64PublicKey)
          loginFormCopy.username = jsencrypt.encrypt(username)
          loginFormCopy.password = jsencrypt.encrypt(password)
          let res = await login(loginFormCopy)
          if (res.success == true) {
            // debugger
            this.loginTip = ''
            this.$emit('loginSuccess', res)
          } else {
            // this.$message.error(res.msg)
            this.loginTip = res.msg
            this.getValidateCode()
          }
          this.loadingBtn = false
        }
      })
    },
    ipLoginClick() {
      ipLogin('TDS').then((res) => {
        if (res.success) {
          this.loginTip = ''
          this.$emit('loginSuccess', res)
        } else {
          // this.$message.error(res.msg)
          this.loginTip = res.msg
        }
      })
    },
    bindPhoneLogin(){
      this.$emit('changeWxBindCom', 'PhoneCom')
    },
  },
}
</script>
<style lang="less" scoped>
.valid-code-container {
  padding: 48px 40px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px 10px 10px 10px;

  .title {
    font-weight: bold;
    font-size: 32px;
    color: #03133d;
    line-height: 34px;

    .high-light {
      margin-left: 10px;
      color: #0677e7;
    }
  }

  .sub-title {
    margin-top: 12px;
    font-size: 18px;
    color: #68718b;
    line-height: 24px;
  }

  .form {
    margin-top: 32px;

    /deep/.el-input__inner {
      width: 380px;
      height: 44px;
      line-height: 44px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #cdd0d8;
    }

    .base64img {
      margin-left: 12px;
      width: 100px;
      height: 38px;
    }

    .inpt-label {
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: bold;
      color: #03133d;
      line-height: 22px;
    }

    .input {
      /deep/.el-input__inner {
        width: 268px;
      }
    }

    .tip {
      position: absolute;
      right: 0;
      bottom: -22px;
      font-size: 14px;
      color: #006fba;
      line-height: 20px;
      cursor: pointer;
    }

    .login_btns {
      display: flex;
      gap: 10px;

      .login-btn {
        flex: 1;
        // width: 380px;
        height: 54px;
        background: linear-gradient(160deg, #0c87f0 0%, #036fe2 100%);
        border-radius: 10px 10px 10px 10px;
        line-height: 54px;
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
      }
    }

    .other_login {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .regist-tip {
        text-align: center;
        font-size: 14px;
        color: #68718b;
      }

      .ip_add {
        font-size: 13px;
        font-weight: bold;
        color: rgb(92, 91, 91);
      }
    }


    .regist-btn {
      color: #006fba;
      font-weight: bold;
    }
  }

  .login-tip {
    margin-bottom: 10px;
    font-size: 12px;
    height: 16px;

    line-height: 16px;
    color: #ff0000;
  }

  .form-bot {
    margin-top: 24px;

    .gap-row {
      font-size: 14px;
      color: #68718b;

      &::before {
        content: '';
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 13px;
        display: inline-block;
        width: 163px;
        height: 1px;
        background-color: #e6e8ec;
      }

      &::after {
        content: '';
        vertical-align: middle;
        margin-left: 13px;
        margin-top: -3px;
        display: inline-block;
        width: 163px;
        height: 1px;
        background-color: #e6e8ec;
      }
    }

    .other-btn {
      margin-top: 24px;
    }

    .btn {
      width: 182px;
      height: 54px;
      text-align: center;
      line-height: 54px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #e6e8ec;
      cursor: pointer;
    }

    .phone-btn {
      margin-right: 16px;

      &::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 12px;
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/login/phone.png);
        background-size: contain;
      }
    }

    .code-btn::before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      margin-top: -3px;
      width: 24px;
      height: 24px;
      margin-right: 12px;
      background-image: url(../../../assets/login/qrcode.png);
      background-size: contain;
    }

    .bind-count {
      width: 380px;
      height: 54px;
      text-align: center;
      line-height: 54px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #e6e8ec;
      cursor: pointer;
      &::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 12px;
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/login/phone.png);
        background-size: contain;
      }
    }
  }
}
</style>
